/* eslint-disable */
export default {
  _1: '1',
  _2: '2',
  _3: '3',
  _4: '4',
  _5: '5',
  _6: '6',
  _7: '7',
  _8: '8',
  _9: '9',
  _10: '10',
  _11: '11',
  _12: '12',
  _13: '13',
  _14: '14',
  _15: '15',
  _16: '16',
  _17: '17',
  _18: '18',
  _19: '19',
  _20: '20',
  _30: '30',
  _40: '40',
  _50: '50',
  _60: '60',
  _70: '70',
  _80: '80',
  _90: '90',
  _100: '100',
  _base_ten_fun_title_vo: 'base_ten_fun_title_vo',
  _change_your_snake_style: 'change_your_snake_style',
  _count_and_write: 'count_and_write',
  _count_write_directions: 'count_write_directions',
  _five_correct_in_a_row: 'five_correct_in_a_row',
  _get_five_correct_in_a_row: 'get_five_correct_in_a_row',
  _hundreds: 'hundreds',
  _listen_and_make: 'listen_and_make',
  _listen_make_directions: 'listen_make_directions',
  _ones: 'ones',
  _read_and_make: 'read_and_make',
  _read_make_directions: 'read_make_directions',
  _select_units: 'select_units',
  _tens: 'tens',
}